export default {
  getRevenueLine: (state) => state.revenueLine,
};
